import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/coiner/account',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Coiner-Index" */ '~/pages/Coiner')
    ),
  },
  {
    path: '/coiner/grant',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Coiner-Grant" */ '~/pages/Coiner/Grant'
        )
    ),
  },
  {
    path: '/coiner/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Coiner-Record" */ '~/pages/Coiner/Record'
        )
    ),
  },
  {
    path: '/coiner/result',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Coiner-Record" */ '~/pages/Coiner/Result'
        )
    ),
  },
  {
    path: '/coiner/partner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Coiner-Partner" */ '~/pages/Coiner/Partner'
        )
    ),
  },
] as RouteConfig[]
